import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from "react";
import { importRemote } from "@module-federation/utilities";
import * as ReactDOM from "react-dom";
const RemoteComponent = ({ url, scope, module, onLoad, onError, }) => {
    url =
        process.env.NODE_ENV === "development"
            ? "https://local.cw.techo.camp:3001"
            : url;
    const [Component, setComponent] = useState(null);
    const [error, setError] = useState(null);
    const mountedRef = useRef(true);
    // Share React and ReactDOM with remote
    // @ts-ignore
    window.React = React;
    // @ts-ignore
    window.ReactDOM = ReactDOM;
    useEffect(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);
    const cleanupContainer = () => {
        try {
            // Clean up window objects by setting to undefined instead of deleting
            // @ts-ignore
            if (window[scope]) {
                // @ts-ignore
                window[scope] = undefined;
            }
            // @ts-ignore
            if (window[`${scope}Chunks`]) {
                // @ts-ignore
                window[`${scope}Chunks`] = undefined;
            }
            // @ts-ignore
            if (window.__webpack_remotes__ && window.__webpack_remotes__[scope]) {
                // @ts-ignore
                window.__webpack_remotes__[scope] = undefined;
            }
        }
        catch (e) {
            console.warn("Warning: Failed to clean up some remote containers", e);
        }
    };
    useEffect(() => {
        let isCurrentMount = true;
        const loadComponent = async () => {
            try {
                // Cleanup previous
                cleanupContainer();
                // Small delay to ensure cleanup is complete
                // await new Promise(resolve => setTimeout(resolve, 50));
                if (!isCurrentMount || !mountedRef.current)
                    return;
                const container = await importRemote({
                    url,
                    scope,
                    module,
                    remoteEntryFileName: "remoteEntry.js",
                    bustRemoteEntryCache: true,
                });
                if (!isCurrentMount || !mountedRef.current)
                    return;
                if (container &&
                    typeof container === "object" &&
                    "default" in container) {
                    const WrappedComponent = (props) => {
                        const RemoteComp = container.default;
                        return React.createElement(RemoteComp, props);
                    };
                    setComponent(() => WrappedComponent);
                    setError(null);
                    onLoad?.();
                }
                else {
                    throw new Error(`Invalid module format from ${url}/${module}`);
                }
            }
            catch (err) {
                if (!isCurrentMount || !mountedRef.current)
                    return;
                console.error("Error loading remote component:", err);
                const errorMessage = err instanceof Error
                    ? err.message
                    : "Failed to load remote component";
                setError(errorMessage);
                setComponent(null);
                onError?.(err instanceof Error ? err : new Error(errorMessage));
            }
        };
        setComponent(null);
        setError(null);
        loadComponent();
        return () => {
            isCurrentMount = false;
            cleanupContainer();
        };
    }, [url, scope, module]);
    if (error) {
        return (_jsx("div", { className: "flex items-center justify-center h-full", children: _jsxs("div", { className: "text-center text-red-500", children: [_jsx("p", { className: "font-medium", children: "Error loading component:" }), _jsx("p", { className: "mt-1", children: error }), _jsxs("p", { className: "mt-2 text-sm text-gray-600", children: ["URL: ", url, _jsx("br", {}), "Module: ", module, _jsx("br", {}), "Scope: ", scope] })] }) }));
    }
    if (!Component) {
        return (_jsx("div", { className: "flex items-center justify-center h-full", children: _jsxs("div", { className: "flex flex-col items-center justify-center text-center", children: [_jsx("div", { className: "w-8 h-8 mb-2 border-b-2 border-gray-900 rounded-full animate-spin" }), _jsx("p", { children: "Loading remote component..." }), _jsxs("p", { className: "mt-2 text-xs text-gray-500", children: [url, "/", module] })] }) }));
    }
    return _jsx(Component, {});
};
export default RemoteComponent;
